import { datadogRum } from '@datadog/browser-rum';
import type { KeycloakUserInfo } from 'keycloak-js';
import type { BuildInfo } from 'app/globalTypes';

export function startRum({ branch, version }: BuildInfo) {
    const { hostname } = window.location;

    if (hostname === 'localhost' || datadogRum.getInitConfiguration()) {
        return;
    }

    const [tenant = '', cluster = ''] = hostname.split('.');
    const recordsReplay =
        ['test', 'user-testing-1', 'user-testing-2', 'ac7936fca0f55'].includes(tenant) ||
        ['ue2-dev', 'trial'].includes(cluster);

    datadogRum.init({
        applicationId: '425d5d66-9525-4ca9-a431-776bb8dff353',
        clientToken: 'pub66f871e435a82d28236ab3b082d43fbf',
        site: 'datadoghq.com',
        service: 'datameer',
        env: branch,
        version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: recordsReplay ? 100 : 0,
        defaultPrivacyLevel: 'mask-user-input',
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackSessionAcrossSubdomains: true,
        beforeSend: (event) =>
            !(event.type === 'error' && event.error.message.includes('ResizeObserver loop'))
    });
    datadogRum.setGlobalContext({ tenantID: tenant, cluster });
}

export function setRumUser({ sub, name, email }: KeycloakUserInfo) {
    datadogRum.setUser({ id: sub, name, email });
}

export function addRumAction(name: string) {
    datadogRum.addAction(name);
}
